export default {"src":"/_next/static/media/money3_02.a19333f2.svg","height":66,"width":230,"blurWidth":0,"blurHeight":0};